import React from "react";
import { SvgIcon, SvgIconProps } from "module/common/component/display";

/**
 * Іконка хрестика (закрити) — дві діагональні лінії з округленими кінцями.
 */
export function CrossIcon(props: Omit<SvgIconProps, "children">): JSX.Element {
    const { color, ...rest } = props;
    return (
        <SvgIcon {...rest} color={color} data-testid="CrossIcon" viewBox="0 0 24 24">
            <line
                x1="6"
                y1="6"
                x2="18"
                y2="18"
                stroke={color || "currentColor"}
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="18"
                y1="6"
                x2="6"
                y2="18"
                stroke={color || "currentColor"}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </SvgIcon>
    );
}
        